import { pickDiary, VIDEO_DIARIES, hasRandomDiaries } from "./videoDiaries";

/**
 * Slot under "WILL SAM MAKE IT HOME?". Hidden while there are no random clips.
 * No pending copy. Diary clips never autoplay.
 */
export function SamVideoDiaries({ trigger = "random", lastId, catalog = VIDEO_DIARIES }) {
  const visible = hasRandomDiaries(catalog);
  const clip = visible ? pickDiary(catalog, { trigger, lastId }) : null;

  return (
    <section
      data-testid="sam-video-diaries"
      hidden={!visible}
      className="mx-auto mt-12 max-w-3xl"
    >
      {visible ? (
        <>
          <p className="mono text-center text-[10px] tracking-[0.3em] text-gmh-cyan">
            VIDEO DIARY — SECTOR 7
          </p>
          {clip ? (
            <video
              data-testid="sam-video-player"
              className="mt-4 w-full border border-[#1c2740] bg-black"
              src={clip.src}
              controls
              playsInline
              muted
              preload="none"
            />
          ) : null}
        </>
      ) : null}
    </section>
  );
}
